export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Tag',
	plural_model_name_spanish: 'Tags',
	create_model_name_spanish: 'Nueva Tag',
	text_delete: 'la',
}